import styled from 'styled-components'
import { Card } from 'antd'

export const StyledCard = styled(Card)`
  margin: 2rem 0 !important;
  max-height: 300px;
  overflow-y: scroll;
`



// WEBPACK FOOTER //
// ./src/components/HandleAgreementModal/styled.js